import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client';

class AmplitudeExperiment {
  client?: ExperimentClient;

  init = async () => {
    this.client = Experiment.initializeWithAmplitudeAnalytics(
      process.env.REACT_APP_AMPLITUDE_EXPERIMENT_KEY || '',
      undefined,
    );
    await this.client.fetch();
  };

  getVariant = (flagKey: string) => {
    const variant = this.client?.variant(flagKey);
    this.client?.exposure(flagKey);
    return variant;
  };

  getAllVariants = () => {
    return this.client?.all();
  };
}

export default new AmplitudeExperiment();
